import { SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Drawer, Input, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { categories } from '../../../constants';
import { setCategory } from '../../../redux/slices/filtersSlice';
import { store } from '../../../redux/store';

const Categories = ({ open, onClose, onApply }) => {
    const { category } = useSelector((state) => state.filtersSlice);
    const [searchCategory, setSearchCategory] = useState('');

    const handleChange = (value) => {
        let updated = [...category];

        updated = updated.filter((f) => !categories.includes(f)).concat(value);


        store.dispatch(setCategory(updated));
    };

    const filteredCategories = useMemo(() => {
        const search = searchCategory.toLowerCase().trim();
        return search ? categories.filter((c) => c.toLowerCase().includes(search)) : categories;
    }, [searchCategory]);

    const handleApply = () => {
        onApply?.();
        onClose();
    };

    return (
        <Drawer
            title="Categories"
            open={open}
            onClose={onClose}
            footer={
                <Button block type="primary" onClick={handleApply}>
                    Apply
                </Button>
            }
        >
            <Input
                size="large"
                placeholder="Search categories"
                prefix={<SearchOutlined />}
                value={searchCategory}
                onChange={(e) => setSearchCategory(e.target.value)}
                allowClear
                className="mb-2"
            />
            <Checkbox.Group
                value={category?.filter((f) => categories.includes(f))}
                onChange={(value) => handleChange(value)}
            >
                <Space direction="vertical">
                    {filteredCategories?.map((category) => (
                        <Checkbox key={category} value={category}>
                            {category}
                        </Checkbox>
                    ))}
                </Space>
            </Checkbox.Group>
        </Drawer>
    );
};

export default Categories;
